/* ======================================================================
   МОДУЛЬ: EXIT-INTENT POPUP (ПОДАРОК ДЛЯ УХОДЯЩИХ ПОСЕТИТЕЛЕЙ)
   (PDF-гайд по разбору 4 стихий натальной карты День 1)
   ====================================================================== */

function hasUserEngaged() {
  try {
    if (typeof isRegistered === 'function' && isRegistered()) return true;
    if (localStorage.getItem('meta_user_registered') === 'true') return true;
    if (localStorage.getItem('meta_user_profile')) return true;
    if (localStorage.getItem('meta_day_1_completed') === 'true') return true;
    const pos = parseFloat(localStorage.getItem('meta_video_pos_day_1') || '0');
    if (pos > 5) return true;
    const pure = parseFloat(localStorage.getItem('meta_video_pure_day_1') || '0');
    if (pure > 5) return true;
  } catch (e) {}
  return false;
}

function initExitIntentModal() {
  // 1. Не показывать тем, кто зарегистрирован или уже начал проходить Урок 1
  if (hasUserEngaged()) {
    return;
  }

  // 2. Проверяем, показывалась ли модалка в текущей сессии
  try {
    if (sessionStorage.getItem('meta_exit_shown') === 'true') {
      return;
    }
  } catch (e) {}

  // 3. Показываем только на главном лендинге (холодный трафик)
  const path = window.location.pathname.toLowerCase();
  const isLanding = path === '/' || 
                    path === '' || 
                    path.endsWith('/index.html') || 
                    path.endsWith('/landing.html');
  if (!isLanding) {
    return;
  }

  const pageStartTime = Date.now();
  let hasTriggered = false;

  function showModal() {
    if (hasTriggered) return;
    if (hasUserEngaged()) return;

    try {
      if (sessionStorage.getItem('meta_exit_shown') === 'true') return;
      sessionStorage.setItem('meta_exit_shown', 'true');
    } catch (e) {}

    hasTriggered = true;

    // Создаем DOM модалки если его нет
    let backdrop = document.getElementById('metaExitIntentBackdrop');
    if (!backdrop) {
      const botUser = window.META_BOT_USERNAME || 'meta_institut_bot';
      const tgUrl = `https://t.me/${botUser}?start=gift_elements`;

      const modalHtml = `
        <div class="meta-exit-backdrop" id="metaExitIntentBackdrop" role="dialog" aria-modal="true">
          <div class="meta-exit-card">
            <button type="button" class="meta-exit-close-btn" id="metaExitCloseBtn" aria-label="Закрыть">✕</button>
            <div class="meta-exit-badge">🎁 Подарок перед уходом</div>
            <h3 class="meta-exit-title">Подождите! Не уходите с пустыми руками</h3>
            <p class="meta-exit-subtitle">Заберите практический материал от Константина Воробьева прямо сейчас:</p>
            
            <div class="meta-exit-gift-box">
              <div class="meta-exit-gift-header">
                <span class="meta-exit-gift-icon">📄</span>
                <span class="meta-exit-gift-name">Шпаргалка: Аптечка 4 стихий. Простые действия для тела и сил (PDF)</span>
              </div>
              <ul class="meta-exit-bullets">
                <li>3 простых шага для каждой стихии (Огонь, Земля, Воздух, Вода)</li>
                <li>Снятие мышечных зажимов и усталости без таблеток</li>
                <li>Ключевые точки компенсаторики тела по натальной карте</li>
              </ul>
            </div>

            <a href="${tgUrl}" target="_blank" rel="noopener noreferrer" class="meta-exit-btn-tg" id="metaExitCtaBtn">
              <span>✈️ Забрать PDF в Telegram (в 1 клик) →</span>
            </a>
            <div class="meta-exit-hint">Файл придет в Telegram сразу после нажатия Start</div>
            <button type="button" class="meta-exit-dismiss-link" id="metaExitDismissBtn">
              Продолжить изучение сайта
            </button>
          </div>
        </div>
      `;
      document.body.insertAdjacentHTML('beforeend', modalHtml);
      backdrop = document.getElementById('metaExitIntentBackdrop');

      const closeBtn = document.getElementById('metaExitCloseBtn');
      const dismissBtn = document.getElementById('metaExitDismissBtn');
      const ctaBtn = document.getElementById('metaExitCtaBtn');

      function hide() {
        if (backdrop) backdrop.classList.remove('is-open');
      }

      if (closeBtn) closeBtn.addEventListener('click', hide);
      if (dismissBtn) dismissBtn.addEventListener('click', hide);
      if (backdrop) {
        backdrop.addEventListener('click', (e) => {
          if (e.target === backdrop) hide();
        });
      }

      if (ctaBtn) {
        ctaBtn.addEventListener('click', (e) => {
          if (typeof trackGoal === 'function') {
            trackGoal('click_exit_intent_elements', { source: 'exit_popup' });
          }
          if (typeof openTelegramBot === 'function') {
            e.preventDefault();
            openTelegramBot('gift_elements');
          }
          setTimeout(hide, 400);
        });
      }
    }

    setTimeout(() => {
      if (backdrop) backdrop.classList.add('is-open');
      if (typeof triggerHaptic === 'function') triggerHaptic('light');
    }, 50);
  }

  let userInteracted = false;
  document.addEventListener('click', function(e) {
    const target = e.target;
    if (target && target.closest('button, a, input, select, textarea, .btn-emerald, #metaChatTriggerBtn, .brand-header-link')) {
      userInteracted = true;
    }
  }, { capture: true, passive: true });

  // Десктопный триггер: реальный увод мыши за пределы вкладки (вверх к вкладкам) после 35 секунд чтения
  document.addEventListener('mouseleave', function(e) {
    if (Date.now() - pageStartTime < 35000) return; // не беспокоить в первые 35 сек
    if (userInteracted) return; // пользователь активно взаимодействует с элементами
    if (e.clientY <= 0 && (!e.relatedTarget && !e.toElement)) {
      showModal();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initExitIntentModal);
} else {
  initExitIntentModal();
}